<template>
  <main class="fixed inset-0 bg-white grid place-items-center px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center max-w-2xl">
      <CheckCircleIcon class="mx-auto h-16 w-16 text-primary-dark sm:h-20 sm:w-20" />
      <h1 class="mt-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        Vous avez été désinscrit avec succès
      </h1>
      <p class="mt-4 text-base leading-7 text-gray-600 sm:text-lg">
        Vous ne recevrez plus d'emails commerciaux de notre part.
      </p>
      <p class="mt-4 text-sm leading-6 text-gray-500">
        Si vous avez changé d'avis, vous pouvez vous réinscrire à tout moment en nous contactant.
      </p>
      <div class="mt-8 flex justify-center">
        <SecondaryButton @click="contactSupport">Nous contacter</SecondaryButton>
      </div>
    </div>
  </main>
</template>

<script>
import { CheckCircleIcon } from "@heroicons/vue/outline";
import { SecondaryButton } from "@estaly/ui";

export default {
  components: {
    CheckCircleIcon,
    SecondaryButton,
  },
  methods: {
    contactSupport() {
      window.location.href = "mailto:contact@estaly.co";
    },
  },
};
</script>
